import * as fromDatatype from "../datatype-library/index";

export interface bl_svc_issue_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  item_name: fromDatatype.VarcharDatatypeInterface;
  serial_no: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  problems_json: any;
  malfunction_date: fromDatatype.TimestampTzDatatypeInterface;
  purchase_date: fromDatatype.TimestampTzDatatypeInterface;
  sales_date: fromDatatype.TimestampTzDatatypeInterface;
  supplier_code: fromDatatype.VarcharDatatypeInterface;
  customer_code: fromDatatype.VarcharDatatypeInterface;
  request_status: fromDatatype.VarcharDatatypeInterface;
  request_action: fromDatatype.VarcharDatatypeInterface;
  tracking_no: fromDatatype.VarcharDatatypeInterface;
  internal_fi_item_code: fromDatatype.VarcharDatatypeInterface;
  internal_fi_item_guid: fromDatatype.GuidDataFieldInterface;
  internal_inv_item_code: fromDatatype.VarcharDatatypeInterface;
  internal_inv_item_guid: fromDatatype.GuidDataFieldInterface;
  purchase_invoice_guid: fromDatatype.GuidDataFieldInterface;
  purchase_invoice_line_guid: fromDatatype.GuidDataFieldInterface;
  sales_invoice_guid: fromDatatype.GuidDataFieldInterface;
  sales_invoice_line_guid: fromDatatype.GuidDataFieldInterface;
  consumer_entity_guid: fromDatatype.GuidDataFieldInterface;
  retailer_entity_guid: fromDatatype.GuidDataFieldInterface;
  vendor_entity_guid: fromDatatype.GuidDataFieldInterface;
  branch_issue_guid: fromDatatype.GuidDataFieldInterface;
  branch_current_guid: fromDatatype.GuidDataFieldInterface;
  branch_doa_guid: fromDatatype.GuidDataFieldInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  server_doc_2: fromDatatype.VarcharDatatypeInterface;
  server_doc_3: fromDatatype.VarcharDatatypeInterface;
  server_doc_4: fromDatatype.VarcharDatatypeInterface;
  server_doc_5: fromDatatype.VarcharDatatypeInterface;
  replace_serial_no: fromDatatype.VarcharDatatypeInterface;
  previous_serial_no: fromDatatype.VarcharDatatypeInterface;
  first_serial_no: fromDatatype.VarcharDatatypeInterface;
  first_issue_hdr_guid: fromDatatype.GuidDataFieldInterface;
  previous_issue_hdr_guid: fromDatatype.GuidDataFieldInterface;
  assignee_guid: fromDatatype.GuidDataFieldInterface;
  property_json: any;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  reason_code: fromDatatype.VarcharDatatypeInterface;
  reason_name: fromDatatype.VarcharDatatypeInterface;
  request_action_code: fromDatatype.VarcharDatatypeInterface;
  request_action_name: fromDatatype.VarcharDatatypeInterface;
  due_date: fromDatatype.TimestampTzDatatypeInterface;
  wf_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  wf_process_status_guid: fromDatatype.GuidDataFieldInterface;
  wf_process_status_code: fromDatatype.VarcharDatatypeInterface;
  wf_resolution_guid: fromDatatype.GuidDataFieldInterface;
  wf_resolution_code: fromDatatype.VarcharDatatypeInterface;
  extended_due_date: fromDatatype.TimestampTzDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  pic_assignee_login_subject_guid: fromDatatype.GuidDataFieldInterface;
  pic_reporter_login_subject_guid: fromDatatype.GuidDataFieldInterface;
  customer_wf_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  customer_wf_process_status_guid: fromDatatype.GuidDataFieldInterface;
  customer_wf_process_status_code: fromDatatype.VarcharDatatypeInterface;
  supplier_wf_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  supplier_wf_process_status_guid: fromDatatype.GuidDataFieldInterface;
  supplier_wf_process_status_code: fromDatatype.VarcharDatatypeInterface;
  phone_number: fromDatatype.VarcharDatatypeInterface;
  branch_name: fromDatatype.VarcharArrayDatatypeInterface;
  uom: fromDatatype.VarcharArrayDatatypeInterface;
  customer_request_date: fromDatatype.TimestampTzDatatypeInterface;
  current_item_type: fromDatatype.VarcharArrayDatatypeInterface;
  entity_code: fromDatatype.VarcharArrayDatatypeInterface;
  entity_name: fromDatatype.VarcharArrayDatatypeInterface;
  email: fromDatatype.VarcharArrayDatatypeInterface;
  gl_code: fromDatatype.VarcharArrayDatatypeInterface;
  entity_type: fromDatatype.VarcharArrayDatatypeInterface;
  identity_type: fromDatatype.VarcharArrayDatatypeInterface;
  entity_description: fromDatatype.VarcharArrayDatatypeInterface;
  customer_ccy_code: fromDatatype.VarcharArrayDatatypeInterface;
  billing_info_json: any;
  shipping_info_json: any;
  sender_info_json: any;
  reference: fromDatatype.VarcharArrayDatatypeInterface;
  terms: fromDatatype.VarcharArrayDatatypeInterface;
  sales_agent_guid: fromDatatype.VarcharArrayDatatypeInterface;
  replacement_item_expiry_date: fromDatatype.TimestampTzDatatypeInterface;
  replacement_item_extended_expiry_date: fromDatatype.TimestampTzDatatypeInterface;
  id_number: fromDatatype.VarcharArrayDatatypeInterface;
  member_guid: fromDatatype.GuidDataFieldInterface;
  crm_contact: fromDatatype.VarcharArrayDatatypeInterface;
  reason_desc: fromDatatype.VarcharArrayDatatypeInterface;
  reason_of_repair: any;

  // EMP RMA related columns
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  company_hdr_guid: fromDatatype.GuidDataFieldInterface;
  location_issue_guid: fromDatatype.GuidDataFieldInterface;
  location_doa_guid: fromDatatype.GuidDataFieldInterface;
  location_current_guid: fromDatatype.GuidDataFieldInterface;
  item_manufacturer: fromDatatype.VarcharDatatypeInterface;
  item_model_code: fromDatatype.VarcharDatatypeInterface;
  cust_doc_entity_hdr_json: any;
  cust_billing_json: any;
  owner_reference_1: fromDatatype.VarcharDatatypeInterface;
  owner_reference_2: fromDatatype.VarcharDatatypeInterface;
  supp_doc_entity_hdr_json: any;
  supp_billing_json: any;
  supplier_reference: fromDatatype.VarcharDatatypeInterface;
  warranty_expiry_date: fromDatatype.TimestampTzDatatypeInterface;
  date_consumer_received: fromDatatype.TimestampTzDatatypeInterface;
  date_consumer_sent_estimate: fromDatatype.TimestampTzDatatypeInterface;
  date_returned_by_supplier: fromDatatype.TimestampTzDatatypeInterface;
  date_received_by_supplier: fromDatatype.TimestampTzDatatypeInterface;
  date_returned_to_supplier: fromDatatype.TimestampTzDatatypeInterface;
  date_received_from_supplier: fromDatatype.TimestampTzDatatypeInterface;
  technician_guid_1: fromDatatype.GuidDataFieldInterface;
  technician_guid_2: fromDatatype.GuidDataFieldInterface;
  technician_guid_3: fromDatatype.GuidDataFieldInterface;
  technician_remarks_1: fromDatatype.VarcharDatatypeInterface;
  technician_remarks_2: fromDatatype.VarcharDatatypeInterface;
  technician_remarks_3: fromDatatype.VarcharDatatypeInterface;
  technician_points_1: fromDatatype.NumericDatatypeInterface;
  technician_points_2: fromDatatype.NumericDatatypeInterface;
  technician_points_3: fromDatatype.NumericDatatypeInterface;
  repair_cost: fromDatatype.NumericDatatypeInterface;
  date_consumer_sent_actual: fromDatatype.TimestampTzDatatypeInterface;
  estimated_delivery_date: fromDatatype.TimestampTzDatatypeInterface;
  actual_delivery_date: fromDatatype.TimestampTzDatatypeInterface;
  merchant_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  qty_base: fromDatatype.NumericDatatypeInterface;
  amount_excl_tax: fromDatatype.NumericDatatypeInterface;
  amount_incl_tax: fromDatatype.NumericDatatypeInterface;
  replacement_logic: fromDatatype.VarcharDatatypeInterface;
  replacement_item_type: fromDatatype.VarcharDatatypeInterface;
  replacement_item_code: fromDatatype.VarcharDatatypeInterface;
  replacement_item_name: fromDatatype.VarcharDatatypeInterface;
  replacement_item_manufacturer: fromDatatype.VarcharDatatypeInterface;
  replacement_item_model: fromDatatype.VarcharDatatypeInterface;
  replacement_item_serial: fromDatatype.VarcharDatatypeInterface;
  replacement_item_description: fromDatatype.VarcharDatatypeInterface;
  replacement_quantity: fromDatatype.NumericDatatypeInterface;
  replacement_unit_price: fromDatatype.NumericDatatypeInterface;
  replacement_unit_charges: fromDatatype.NumericDatatypeInterface;
  replacement_price: fromDatatype.NumericDatatypeInterface;
  replacement_doc_ref: fromDatatype.VarcharDatatypeInterface;
  replacement_doc_key: fromDatatype.NumericDatatypeInterface;
  external_svc_note_no: fromDatatype.VarcharDatatypeInterface;
  rma_type: fromDatatype.VarcharDatatypeInterface;
  faulty_goods_pickup_type: fromDatatype.VarcharDatatypeInterface;
  parts_cost: fromDatatype.NumericDatatypeInterface;
  disposal_cost: fromDatatype.NumericDatatypeInterface;
  labour_cost: fromDatatype.NumericDatatypeInterface;
  gov_tax: fromDatatype.NumericDatatypeInterface;
  total_charges: fromDatatype.NumericDatatypeInterface;
  paid_amount: fromDatatype.NumericDatatypeInterface;

  // TODO: Add this when the BE server is updated
  // merchant_name: fromDatatype.VarcharDatatypeInterface;
  // posting_status: fromDatatype.VarcharDatatypeInterface;
  quantity: fromDatatype.NumericDatatypeInterface;
}

export class bl_svc_issue_hdr_RowClass
  implements bl_svc_issue_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  item_name: fromDatatype.VarcharDatatypeInterface;
  serial_no: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  problems_json: any;
  malfunction_date: fromDatatype.TimestampTzDatatypeInterface;
  purchase_date: fromDatatype.TimestampTzDatatypeInterface;
  sales_date: fromDatatype.TimestampTzDatatypeInterface;
  supplier_code: fromDatatype.VarcharDatatypeInterface;
  customer_code: fromDatatype.VarcharDatatypeInterface;
  request_status: fromDatatype.VarcharDatatypeInterface;
  request_action: fromDatatype.VarcharDatatypeInterface;
  tracking_no: fromDatatype.VarcharDatatypeInterface;
  internal_fi_item_code: fromDatatype.VarcharDatatypeInterface;
  internal_fi_item_guid: fromDatatype.GuidDataFieldInterface;
  internal_inv_item_code: fromDatatype.VarcharDatatypeInterface;
  internal_inv_item_guid: fromDatatype.GuidDataFieldInterface;
  purchase_invoice_guid: fromDatatype.GuidDataFieldInterface;
  purchase_invoice_line_guid: fromDatatype.GuidDataFieldInterface;
  sales_invoice_guid: fromDatatype.GuidDataFieldInterface;
  sales_invoice_line_guid: fromDatatype.GuidDataFieldInterface;
  consumer_entity_guid: fromDatatype.GuidDataFieldInterface;
  retailer_entity_guid: fromDatatype.GuidDataFieldInterface;
  vendor_entity_guid: fromDatatype.GuidDataFieldInterface;
  branch_issue_guid: fromDatatype.GuidDataFieldInterface;
  branch_current_guid: fromDatatype.GuidDataFieldInterface;
  branch_doa_guid: fromDatatype.GuidDataFieldInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  server_doc_2: fromDatatype.VarcharDatatypeInterface;
  server_doc_3: fromDatatype.VarcharDatatypeInterface;
  server_doc_4: fromDatatype.VarcharDatatypeInterface;
  server_doc_5: fromDatatype.VarcharDatatypeInterface;
  replace_serial_no: fromDatatype.VarcharDatatypeInterface;
  previous_serial_no: fromDatatype.VarcharDatatypeInterface;
  first_serial_no: fromDatatype.VarcharDatatypeInterface;
  first_issue_hdr_guid: fromDatatype.GuidDataFieldInterface;
  previous_issue_hdr_guid: fromDatatype.GuidDataFieldInterface;
  assignee_guid: fromDatatype.GuidDataFieldInterface;
  property_json: any;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  reason_code: fromDatatype.VarcharDatatypeInterface;
  reason_name: fromDatatype.VarcharDatatypeInterface;
  request_action_code: fromDatatype.VarcharDatatypeInterface;
  request_action_name: fromDatatype.VarcharDatatypeInterface;
  due_date: fromDatatype.TimestampTzDatatypeInterface;
  wf_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  wf_process_status_guid: fromDatatype.GuidDataFieldInterface;
  wf_process_status_code: fromDatatype.VarcharDatatypeInterface;
  wf_resolution_guid: fromDatatype.GuidDataFieldInterface;
  wf_resolution_code: fromDatatype.VarcharDatatypeInterface;
  extended_due_date: fromDatatype.TimestampTzDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  pic_assignee_login_subject_guid: fromDatatype.GuidDataFieldInterface;
  pic_reporter_login_subject_guid: fromDatatype.GuidDataFieldInterface;
  customer_wf_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  customer_wf_process_status_guid: fromDatatype.GuidDataFieldInterface;
  customer_wf_process_status_code: fromDatatype.VarcharDatatypeInterface;
  supplier_wf_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  supplier_wf_process_status_guid: fromDatatype.GuidDataFieldInterface;
  supplier_wf_process_status_code: fromDatatype.VarcharDatatypeInterface;
  phone_number: fromDatatype.VarcharDatatypeInterface;
  branch_name: fromDatatype.VarcharArrayDatatypeInterface;
  uom: fromDatatype.VarcharArrayDatatypeInterface;
  customer_request_date: fromDatatype.TimestampTzDatatypeInterface;
  current_item_type: fromDatatype.VarcharArrayDatatypeInterface;
  entity_code: fromDatatype.VarcharArrayDatatypeInterface;
  entity_name: fromDatatype.VarcharArrayDatatypeInterface;
  email: fromDatatype.VarcharArrayDatatypeInterface;
  gl_code: fromDatatype.VarcharArrayDatatypeInterface;
  entity_type: fromDatatype.VarcharArrayDatatypeInterface;
  identity_type: fromDatatype.VarcharArrayDatatypeInterface;
  entity_description: fromDatatype.VarcharArrayDatatypeInterface;
  customer_ccy_code: fromDatatype.VarcharArrayDatatypeInterface;
  billing_info_json: any;
  shipping_info_json: any;
  sender_info_json: any;
  reference: fromDatatype.VarcharArrayDatatypeInterface;
  terms: fromDatatype.VarcharArrayDatatypeInterface;
  sales_agent_guid: fromDatatype.VarcharArrayDatatypeInterface;
  replacement_item_expiry_date: fromDatatype.TimestampTzDatatypeInterface;
  replacement_item_extended_expiry_date: fromDatatype.TimestampTzDatatypeInterface;
  id_number: fromDatatype.VarcharArrayDatatypeInterface;
  member_guid: fromDatatype.GuidDataFieldInterface;
  crm_contact: fromDatatype.VarcharArrayDatatypeInterface;
  reason_desc: fromDatatype.VarcharArrayDatatypeInterface;
  reason_of_repair: any;
  
  // EMP RMA related columns
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  company_hdr_guid: fromDatatype.GuidDataFieldInterface;
  location_issue_guid: fromDatatype.GuidDataFieldInterface;
  location_doa_guid: fromDatatype.GuidDataFieldInterface;
  location_current_guid: fromDatatype.GuidDataFieldInterface;
  item_manufacturer: fromDatatype.VarcharDatatypeInterface;
  item_model_code: fromDatatype.VarcharDatatypeInterface;
  cust_doc_entity_hdr_json: any;
  cust_billing_json: any;
  owner_reference_1: fromDatatype.VarcharDatatypeInterface;
  owner_reference_2: fromDatatype.VarcharDatatypeInterface;
  supp_doc_entity_hdr_json: any;
  supp_billing_json: any;
  supplier_reference: fromDatatype.VarcharDatatypeInterface;
  warranty_expiry_date: fromDatatype.TimestampTzDatatypeInterface;
  date_consumer_received: fromDatatype.TimestampTzDatatypeInterface;
  date_consumer_sent_estimate: fromDatatype.TimestampTzDatatypeInterface;
  date_returned_by_supplier: fromDatatype.TimestampTzDatatypeInterface;
  date_received_by_supplier: fromDatatype.TimestampTzDatatypeInterface;
  date_returned_to_supplier: fromDatatype.TimestampTzDatatypeInterface;
  date_received_from_supplier: fromDatatype.TimestampTzDatatypeInterface;
  technician_guid_1: fromDatatype.GuidDataFieldInterface;
  technician_guid_2: fromDatatype.GuidDataFieldInterface;
  technician_guid_3: fromDatatype.GuidDataFieldInterface;
  technician_remarks_1: fromDatatype.VarcharDatatypeInterface;
  technician_remarks_2: fromDatatype.VarcharDatatypeInterface;
  technician_remarks_3: fromDatatype.VarcharDatatypeInterface;
  technician_points_1: fromDatatype.NumericDatatypeInterface;
  technician_points_2: fromDatatype.NumericDatatypeInterface;
  technician_points_3: fromDatatype.NumericDatatypeInterface;
  repair_cost: fromDatatype.NumericDatatypeInterface;
  date_consumer_sent_actual: fromDatatype.TimestampTzDatatypeInterface;
  estimated_delivery_date: fromDatatype.TimestampTzDatatypeInterface;
  actual_delivery_date: fromDatatype.TimestampTzDatatypeInterface;
  merchant_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  qty_base: fromDatatype.NumericDatatypeInterface;
  amount_excl_tax: fromDatatype.NumericDatatypeInterface;
  amount_incl_tax: fromDatatype.NumericDatatypeInterface;
  replacement_logic: fromDatatype.VarcharDatatypeInterface;
  replacement_item_type: fromDatatype.VarcharDatatypeInterface;
  replacement_item_code: fromDatatype.VarcharDatatypeInterface;
  replacement_item_name: fromDatatype.VarcharDatatypeInterface;
  replacement_item_manufacturer: fromDatatype.VarcharDatatypeInterface;
  replacement_item_model: fromDatatype.VarcharDatatypeInterface;
  replacement_item_serial: fromDatatype.VarcharDatatypeInterface;
  replacement_item_description: fromDatatype.VarcharDatatypeInterface;
  replacement_quantity: fromDatatype.NumericDatatypeInterface;
  replacement_unit_price: fromDatatype.NumericDatatypeInterface;
  replacement_unit_charges: fromDatatype.NumericDatatypeInterface;
  replacement_price: fromDatatype.NumericDatatypeInterface;
  replacement_doc_ref: fromDatatype.VarcharDatatypeInterface;
  replacement_doc_key: fromDatatype.NumericDatatypeInterface;
  external_svc_note_no: fromDatatype.VarcharDatatypeInterface;

  // TODO: Add this when the BE server is updated
  // merchant_name: fromDatatype.VarcharDatatypeInterface;
  // posting_status: fromDatatype.VarcharDatatypeInterface;
  quantity: fromDatatype.NumericDatatypeInterface;
  rma_type: fromDatatype.VarcharDatatypeInterface;
  faulty_goods_pickup_type: fromDatatype.VarcharDatatypeInterface;
  parts_cost: fromDatatype.NumericDatatypeInterface;
  disposal_cost: fromDatatype.NumericDatatypeInterface;
  labour_cost: fromDatatype.NumericDatatypeInterface;
  gov_tax: fromDatatype.NumericDatatypeInterface;
  total_charges: fromDatatype.NumericDatatypeInterface;
  paid_amount: fromDatatype.NumericDatatypeInterface;
}
